/* The monthly chart's furniture. Tokens only (ADR-0007): no colour literal, and the brand green
   colours nothing here. The chart scrolls sideways inside its own box at phone width, never the
   page - `.scroller` is the only element that overflows. */

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: 0 0 8px;
  padding: 0;
  list-style: none;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.legendItem {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.swatch {
  width: 10px;
  height: 10px;
  flex: 0 0 auto;
  border-radius: 2px;
}

/* A scope that is not assessed has an outline and no fill, so the legend cannot be read as a
   fourth colour in use. */
.swatchOff,
.swatchEmpty {
  border: 1px dashed var(--muted);
  background: none;
}

.swatchHatch {
  background: repeating-linear-gradient(135deg, var(--ink-2) 0 2px, var(--panel) 2px 4px);
}

.swatchOpen {
  border: 1.5px dashed var(--ink);
  background: none;
}

.approx {
  font-weight: 600;
  color: var(--ink);
}

.scroller {
  max-width: 100%;
  overflow: auto hidden;
  padding-bottom: 4px;
}

.svg {
  display: block;
  overflow: visible;
  max-width: none;
}

.tick {
  font-variant-numeric: lining-nums tabular-nums;
}

.slot {
  cursor: pointer;
  outline: none;
}

.hit {
  fill: var(--panel-2);
  fill-opacity: 0;
  stroke: none;
}

.slot:hover .hit {
  fill-opacity: 0.7;
}

.hitOn {
  fill-opacity: 1;
  stroke: var(--line-2);
}

.slot:focus-visible .hit {
  stroke: var(--ink);
  stroke-width: 2;
  fill-opacity: 0.7;
}

.notes {
  margin: 8px 0 0;
  padding-left: 18px;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
  max-width: 100ch;
}

.reconcile {
  margin: 8px 0 0;
  color: var(--ink-2);
  font-size: var(--t-min);
  line-height: 1.5;
}

.alert {
  margin: 0;
  padding: 10px 12px;
  border: 1px solid var(--warn);
  border-radius: var(--radius-ctl);
  color: var(--ink);
  font-size: var(--t-dense);
  line-height: 1.5;
}

.detail {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--line);
  font-size: var(--t-dense);
  color: var(--ink);
}

.hint {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-min);
}

.detailHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.detailTitle {
  margin: 0;
  font-size: var(--t-dense);
  font-weight: 600;
}

.close,
.open {
  font: inherit;
  font-size: var(--t-min);
  color: var(--ink);
  background: none;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  padding: 4px 10px;
  cursor: pointer;
}

.close:hover,
.open:hover {
  background: var(--panel-2);
}

.open {
  margin-top: 8px;
}

.detailLine {
  margin: 6px 0 0;
  color: var(--ink-2);
  font-size: var(--t-min);
  line-height: 1.5;
  max-width: 90ch;
}

.fine {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
  max-width: 90ch;
}

.values {
  margin: 8px 0 0;
  display: grid;
  gap: 2px;
  max-width: 360px;
}

.valueRow {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.valueRow dt {
  color: var(--ink-2);
}

.valueRow dd {
  margin: 0;
  font-variant-numeric: lining-nums tabular-nums;
}

.valueTotal {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid var(--line);
  font-weight: 600;
}

.fallback {
  margin-top: 12px;
  color: var(--ink-2);
  font-size: var(--t-min);
}

.fallback summary {
  cursor: pointer;
  padding: 4px 0;
}

.tableWrap {
  max-width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  min-width: 640px;
  margin-top: 8px;
  border-collapse: collapse;
  font-variant-numeric: lining-nums tabular-nums;
}

.table caption {
  text-align: left;
  color: var(--muted);
  padding-bottom: 4px;
}

.table th,
.table td {
  padding: 6px 7px;
  border-bottom: 1px solid var(--line);
  text-align: left;
  vertical-align: top;
}

.table .n {
  text-align: right;
}

.table tfoot th,
.table tfoot td {
  border-top: 1px solid var(--line-2);
  font-weight: 600;
}
